export var ExtraInteractionsEvents;
(function (ExtraInteractionsEvents) {
    ExtraInteractionsEvents["InteractionError"] = "InteractionError";
    ExtraInteractionsEvents["InteractionCalled"] = "InteractionCalled";
})(ExtraInteractionsEvents || (ExtraInteractionsEvents = {}));
//# sourceMappingURL=interactionsTypes.js.map